var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2132 2.26925H13.4632V0.840681C13.4632 0.742467 13.3828 0.662109 13.2846 0.662109H12.0346C11.9364 0.662109 11.856 0.742467 11.856 0.840681V2.26925H6.14174V0.840681C6.14174 0.742467 6.06138 0.662109 5.96317 0.662109H4.71317C4.61496 0.662109 4.5346 0.742467 4.5346 0.840681V2.26925H0.784598C0.389509 2.26925 0.0703125 2.58845 0.0703125 2.98354V17.805C0.0703125 18.2001 0.389509 18.5193 0.784598 18.5193H17.2132C17.6083 18.5193 17.9275 18.2001 17.9275 17.805V2.98354C17.9275 2.58845 17.6083 2.26925 17.2132 2.26925ZM16.3203 16.9121H1.67746V8.42997H16.3203V16.9121ZM1.67746 6.91211V3.8764H4.5346V4.94782C4.5346 5.04604 4.61496 5.1264 4.71317 5.1264H5.96317C6.06138 5.1264 6.14174 5.04604 6.14174 4.94782V3.8764H11.856V4.94782C11.856 5.04604 11.9364 5.1264 12.0346 5.1264H13.2846C13.3828 5.1264 13.4632 5.04604 13.4632 4.94782V3.8764H16.3203V6.91211H1.67746Z",
    fill: "black",
    fillOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.2e48d2a3806aa1acc804147765090f9a.svg";
export { ForwardRef as ReactComponent };